import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Upload, Loader2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export const PhotoPicker = ({ estId, onConfirm, onCancel, confirmLabel, busy, testid, intro }) => {
  const [photos, setPhotos] = useState(null);
  const [selected, setSelected] = useState(null);
  const [uploading, setUploading] = useState(false);
  useEffect(() => { api.get(`/establishments/${estId}/photos`).then((r) => { setPhotos(r.data); if (r.data[0]) setSelected(r.data[0].id); }); }, [estId]);

  const upload = async (file) => {
    if (!file) return;
    setUploading(true);
    const fd = new FormData(); fd.append("file", file); fd.append("kind", "product");
    try { const { data } = await api.post(`/establishments/${estId}/photos`, fd, { headers: { "Content-Type": "multipart/form-data" } }); setPhotos((p) => [data, ...(p || [])]); setSelected(data.id); toast.success("Photo réelle importée"); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Import impossible"); }
    finally { setUploading(false); }
  };

  return (
    <div className="rounded-xl bg-white border border-slate-200 p-3 space-y-2" data-testid={testid}>
      <p className="text-sm text-slate-800 font-medium">{intro || "Choisissez une vraie photo (plat, produit, salon, réalisation, véhicule…)."}</p>
      <p className="text-xs text-slate-500">Photo réelle fournie par vous, jamais présentée comme générée. Respondia n'invente ni produit, ni décor.</p>
      <div className="flex gap-2 flex-wrap items-center">
        <label className="inline-flex items-center gap-2 h-10 px-3 rounded-lg bg-blue-600 text-white text-sm cursor-pointer" data-testid={`${testid}-upload`}>
          {uploading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />} Importer une photo
          <input type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={(e) => upload(e.target.files?.[0])} />
        </label>
        {photos?.map((p) => <button key={p.id} onClick={() => setSelected(p.id)} className={`relative w-14 h-14 rounded-lg overflow-hidden border-2 ${selected === p.id ? "border-blue-600" : "border-slate-200"}`} data-testid={`photo-pick-${p.id}`}><img src={`${API}/photos/${p.id}/image`} alt={p.caption || "Photo réelle"} className="w-full h-full object-cover" /><span className="absolute bottom-0 inset-x-0 text-[8px] bg-emerald-600 text-white text-center">réelle</span></button>)}
      </div>
      <div className="flex gap-2">
        <Button size="sm" disabled={!selected || busy} onClick={() => onConfirm(selected)} className="h-10 rounded-lg bg-slate-900 hover:bg-slate-800" data-testid={`${testid}-confirm`}>{busy ? <Loader2 className="w-4 h-4 mr-1.5 animate-spin" /> : null}{confirmLabel}</Button>
        <Button size="sm" variant="ghost" onClick={onCancel} className="h-10">Annuler</Button>
      </div>
    </div>
  );
};
